
<app-line-chart [data]="data.amortizationTable" [expenses]="data.totalExpenses"></app-line-chart>
